import { faArrowLeft, faKey, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../../Shared/Form/Button';
import Form from '../../Shared/Form/Form';
import Input from '../../Shared/Form/Input';
import Title from '../../Shared/Title';
import SidePanelWrapper from './../SidePanelWrapper';
import DigipasLogoWidePNG from "../../../Assets/digipaslogowide.png";
import { useAppSelector } from "../../../Redux/store";
import StatusPopups from "../../Shared/Form/StatusPopups";
import BusyArea from "../../Shared/BusyArea";
import { useResetPasswordMutation } from "../../../Redux/Api/Auth";
import LanguageDropdown from '../../Shared/LanguageDropdown';
import { useTranslation } from "react-i18next";
import { min } from '../../../Utils/InValidation';
import IconSVG from '../../../Assets/icon.svg?component';
import { faCancel } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ResetPasswordPage = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const logoutError = useAppSelector((s) => s.auth.logoutReason);

    const [error, setError] = useState<string | undefined>(logoutError);
    const [submitted, setSubmitted] = useState(false);
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [busy, setBusy] = useState(false);
    const [params] = useSearchParams();
    const [resetPassword] = useResetPasswordMutation();

    useEffect(() => {
        const pathSegments = window.location.pathname.split('/');
        const currentLang = pathSegments[1].toLowerCase();
        const validLanguages = ['nl', 'en', 'de', 'fr', 'es'];

        if (validLanguages.includes(currentLang)) {
            i18n.changeLanguage(currentLang).then(() => {
            });
        }
    }, [i18n]);

    const submit = async (data: { password: string; confirmPassword: string }) => {
        if (busy) return;
        setSubmitted(true);

        setBusy(true);
        setSuccessMessage('');
        setError('');

        if (data.password !== data.confirmPassword) {
            setError(t("resetPassword:error") || "");
            setBusy(false);
            return;
        }

        const token = params.get("token");
        if (!token) {
            setError(t("resetPassword:error") as string);
            setBusy(false);
            return;
        }

        try {
            await resetPassword([token, data.password]).unwrap();
            setSuccessMessage(t("resetPassword:success") || "");
            setTimeout(() => navigate(`/${i18n.language}/login`), 2000);
        } catch (e) {
            setError(t("resetPassword:error") || "");
        }
        setBusy(false);
    };

    return (
        <>
            <SidePanelWrapper style={{ position: 'relative', display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '100vh', backgroundColor: 'white' }}>
                <StatusPopups setText={setSuccessMessage} type='success' text={successMessage} />
                <StatusPopups setText={setError} type='error' text={error} />
                <Title center text={t("resetPassword:resetPassword")} subtitle={t("resetPassword:resetPasswordPrefix") || ""} />
                <BusyArea busy={busy}>
                    <div className='flex justify-between items-center absolute top-0 left-0 p-5 w-full'>
                        <div className='text-brand flex items-center gap-2 font-bold'><IconSVG className='w-10 h-10' /><span className='text-2xl ml-1 font-app'>D I G I P A S</span></div>
                        <LanguageDropdown />
                    </div>
                    <Form submit={submit}>
                        <Input submitted={submitted ? true : false} required invalidator={min(8)} label={t("resetPassword:passwordNew")} type='password' id='password' />
                        <Input submitted={submitted ? true : false} required invalidator={min(8)} label={t("resetPassword:passwordRepeat")} type='password' id='confirmPassword' />
                        <div className="flex w-full mb-4">
                            <Button title={t('resetPassword:confirm')} icon={busy ? faSpinner : faKey} className="flex-1 py-2 " />
                        </div>
                        <div className="flex mt-10">
                            <Link to={`/${i18n.language}/login`} style={{ fontSize: '16px' }} className="w-full text-center no-underline hover:underline flex items-center justify-center">
                                <FontAwesomeIcon icon={faCancel} className='mr-2 h-3.5' />{t('resetPassword:cancel')}
                            </Link>
                        </div>
                    </Form>
                </BusyArea>
            </SidePanelWrapper>
        </>
    );
};

export default ResetPasswordPage;
